/** Cell access for the rules (docs/spec/02 §1). Outside the cave counts as steel. */

import { E } from './elements';
import type { CaveState, Dir } from './types';
import { DX, DY } from './types';

export function at(s: CaveState, x: number, y: number): number {
  if (x < 0 || y < 0 || x >= s.w || y >= s.h) return E.STEEL;
  return s.cells[y * s.w + x] ?? E.STEEL;
}

/** Write in place: the rule's own cell, which has already been visited. */
export function put(s: CaveState, x: number, y: number, el: number): void {
  if (x < 0 || y < 0 || x >= s.w || y >= s.h) return;
  s.cells[y * s.w + x] = el;
}

/** Write another cell and stamp it, so it does not act again this scan. */
export function store(s: CaveState, x: number, y: number, el: number): void {
  if (x < 0 || y < 0 || x >= s.w || y >= s.h) return;
  const i = y * s.w + x;
  s.cells[i] = el;
  s.stamp[i] = s.scan;
}

/** Move whatever is at (x, y) one cell in `dir`, as `el`, leaving space behind. */
export function move(s: CaveState, x: number, y: number, dir: Dir, el: number): void {
  const nx = x + (DX[dir] ?? 0);
  const ny = y + (DY[dir] ?? 0);
  put(s, x, y, E.SPACE);
  store(s, nx, ny, el);
  if (nx >= 0 && ny >= 0 && nx < s.w && ny < s.h) s.moved[ny * s.w + nx] = dir;
}

export function isSpace(s: CaveState, x: number, y: number): boolean {
  return at(s, x, y) === E.SPACE;
}
